import { render, staticRenderFns } from "./XInputDevotionCategory.vue?vue&type=template&id=40360010"
import script from "./XInputDevotionCategory.vue?vue&type=script&lang=js"
export * from "./XInputDevotionCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports